import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ErrorText = styled.div`
  color: ${({ theme }) => theme.error?.main || '#d32f2f'};
  font-size: 12px;
  margin-top: 4px;
`

export const HelpText = styled.div`
  color: ${({ theme }) => theme.grey?.[600] || '#666'};
  font-size: 12px;
  margin-top: 4px;
`
